class TestimonialsGrid extends HTMLElement {
  connectedCallback() {
    this.cards = Array.from(this.querySelectorAll(".ts_card"));
    if (!this.cards.length) return;

    this.setupReveal();
  }

  setupReveal() {
    if (!("IntersectionObserver" in window)) return;

    this.cards.forEach((card, index) => {
      card.style.setProperty("--ts-reveal-delay", `${index * 140}ms`);
      card.classList.add("ts_card--will-reveal");
    });

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          this.cards.forEach((card) => card.classList.add("is-in-view"));
          observer.disconnect();
        });
      },
      { threshold: 0.15, rootMargin: "0px 0px -40px 0px" },
    );

    observer.observe(this.querySelector(".ts_grid") || this);
  }
}

customElements.define("testimonials-grid", TestimonialsGrid);
